import { Input } from "../ui/input";
import { Label } from "../ui/label";

export const TextInput = (props) => {
  const { description = "", label = "", ...restProps } = props;

  return (
    <div className="space-y-2">
      {label ? <Label>{label}</Label> : null}
      <Input {...restProps} />
      {description ? (
        <p className="text-xs text-muted-foreground">{description}</p>
      ) : null}
    </div>
  );
};

export default TextInput;
